<template>
  <el-dialog
      :title="setId?'编辑考试说明':'新增考试说明'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="70%"
      center>
    <el-form :model="explainForm" :rules="rules" ref="explainForm" label-width="100px">
      <el-form-item label="考试类型" prop="type">
        <el-select v-model="explainForm.type" placeholder="请选择考试类型" style="width: 100%">
          <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考试说明" prop="name">
        <el-input v-model="explainForm.name" placeholder="请输入说明"></el-input>
      </el-form-item>
      <el-form-item label="详情" prop="desc">
        <VueUditorWrap v-model="explainForm.desc" :config="myConfig"></VueUditorWrap>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('explainForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('explainForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {examExplainAdd} from "@/api/projectOffice";
import {bdEditConfig} from "@/tools/utils";
import VueUditorWrap from 'vue-ueditor-wrap'

export default {
  name: "explainDialog",
  components: {VueUditorWrap},
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {

    return {
      types: [
        {
          id: 1,
          name: '基础知识'
        },
        {
          id: 2,
          name: '案例考试'
        }
      ],
      explainForm: {
        type: '',
        name: '',
        desc: ''

      },
      rules: {
        type: [{required: true, message: '请选择考试类型', trigger: 'change'}],
        name: [
          {required: true, message: '请输入说明', trigger: 'blur'},
        ],
        desc: [
          {required: true, message: '请输入详情', trigger: 'blur'},
        ]
      },
      myConfig: bdEditConfig()
    }
  },
  created() {

  },
  methods: {

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await examExplainAdd(
          this.explainForm.type,
          this.explainForm.name,
          this.explainForm.desc,
          this.setId ? this.setId : ''
      );
      this.$message.success(_state.msg);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    setItem() {
      this.explainForm = {
        type: this.setItem.type ? Number(this.setItem.type) : '',
        name: this.setItem.name,
        desc: this.setItem.desc
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>